import { useState } from 'react'
import Modal from 'react-modal'
import { FormattedMessage } from 'react-intl'

export default function SelectSingleGuest({ isOpen, roomTitle, totalPeople, onSelect }) {
  const [selectedType, updateType] = useState(false)
  const [formSubmitted, submitForm] = useState(false)

  function onClick() {
    submitForm(true)

    if(selectedType) {
      onSelect(selectedType === 'diver')
      submitForm(false)
      updateType(false)
    }
  }

  function handleOptionChange(changeEvent) {
    updateType(changeEvent.target.value)
  }
  return (
    <Modal isOpen={isOpen}
      ariaHideApp={false}
      className='Modal react-popup guest-to-shared-picker form-popup'
      overlayClassName='Overlay'
      contentLabel='Booking enquire popup'>
      <p className='title'>{roomTitle}</p>
      <p>
        <FormattedMessage id='one_go_to_separate_room'
          values={{
            totalPeople,
          }}
          defaultMessage='You have chosen to book a trip for {totalPeople} guests. Given the maximum occupancy levels of the chosen cabin, 1 guest will be in a separate cabin. Is this person a Diver or a Non-Diver?' />
      </p>
      <div>
        <div className='checkbox-wrap'>
          <label className={`checkbox-wrap ${!selectedType && formSubmitted ? 'has-error' : ''}`}>
            <input type='radio' name='selected' onChange={handleOptionChange} id='selected' value='diver' checked={selectedType === 'diver'} /><span />
            <p><FormattedMessage id='diver' defaultMessage='Diver' /></p>
          </label>
          <label className={`checkbox-wrap ${!selectedType && formSubmitted ? 'has-error' : ''}`}>
            <input type='radio' name='selected' onChange={handleOptionChange} id='selected' value='non-diver' checked={selectedType === 'non-diver'} /><span />
            <p><FormattedMessage id='non-diver' defaultMessage='Non-diver' /></p>
          </label>
        </div>
      </div>
      <div className='form-bottom'>
        { formSubmitted && !selectedType && (
          <p className='error-msg' ng-show='!ctrl.diver &amp;&amp; ctrl.submited'>
            <FormattedMessage id='we_need_this' defaultMessage='We need this information to apply the correct price, please make a selection' />
          </p>
        )
        }
        <div className='btn-wrap'>
          <button className='btn-red' onClick={onClick}>
            <FormattedMessage id='continue' defaultMessage='Continue' />
          </button>
        </div>
      </div>
  </Modal>)
}
